import React, { PropsWithChildren } from 'react'
import './integrations-col.scss'
import classnames from 'classnames'

type IntegrationsColProps = {
    loading?: boolean
    className?: string
    label: string
}

export const IntegrationsCol: React.FC<PropsWithChildren<IntegrationsColProps>> = ({
    loading,
    label,
    className,
    children,
}) => {
    return (
        <div className={classnames('integrations-col', className, { loading })}>
            <div className="integrations-col-label">{label}</div>
            <div className="integrations-col-content">{children}</div>
        </div>
    )
}
